export const layoutConstants = {
  headerHeight: '72px',
  mobileHeaderHeight: '58px',
  mobileBannerHeight: '30px',
  footerHeight: '30px',

  maxWidth: '2560px',
};
